document.addEventListener('DOMContentLoaded', function () {
    // Check if we have stored client data from dashboard
    const storedClientData = localStorage.getItem('selectedClient');

    if (storedClientData) {
        const clientData = JSON.parse(storedClientData);

        // Always populate client name
        if (clientData.clientName) {
            document.getElementById('clientName').value = clientData.clientName;
        }
        
        // Populate policy number if available
        const policySelect = document.getElementById('policyNumber');
        if (clientData.policyNumber && policySelect) {
            // Create and select the option
            const option = new Option(clientData.policyNumber, clientData.policyNumber);
            option.selected = true;
            policySelect.innerHTML = ''; // Clear existing options
            policySelect.add(option);
        }
        
        // Populate vehicle registration if available
        if (clientData.vehicleRegistration) {
            document.getElementById('vehicleRegistration').value = clientData.vehicleRegistration;
        }
        
        // Populate driver name if available
        if (clientData.driverName) {
            document.getElementById('driverName').value = clientData.driverName;
        }

        // Clear the localStorage to avoid issues with future direct visits to this page
        localStorage.removeItem('selectedClient');
    }
    
    document.querySelectorAll('.new-claim-btn').forEach(button => {
        button.addEventListener('click', function (e) {
            const clientName = this.getAttribute('data-client');

            // Only store the client name
            const clientData = {
                clientName: clientName
            };

            localStorage.setItem('selectedClient', JSON.stringify(clientData));
        });
    });
    const clientData = [
        {
            id: 1,
            name: "Sprint Courier Ltd",
            policies: [
                {
                    policyNumber: "POL-1001",
                    vehicles: [
                        { vrn: "AB12 CDE", drivers: ["John Smith", "Emma Johnson"] },
                        { vrn: "XY15 ZAB", drivers: ["Michael Brown", "Sarah Davis"] }
                    ]
                }
            ]
        },
        {
            id: 2,
            name: "Value Car Rental UK",
            policies: [
                {
                    policyNumber: "POL-1002",
                    vehicles: [
                        { vrn: "CD34 EFG", drivers: ["Robert Wilson", "Linda Taylor"] },
                        { vrn: "FG56 HIJ", drivers: ["David Miller", "Jennifer Anderson"] }
                    ]
                }
            ]
        },
        {
            id: 3,
            name: "Fast-Food Deliveries",
            policies: [
                {
                    policyNumber: "POL-1003",
                    vehicles: [
                        { vrn: "KL78 MNO", drivers: ["Thomas Moore", "Patricia White"] },
                        { vrn: "PQ90 RST", drivers: ["James Martin", "Elizabeth Clark"] }
                    ]
                }
            ]
        },
        {
            id: 4,
            name: "Auto Driving School",
            policies: [
                {
                    policyNumber: "POL-1004",
                    vehicles: [
                        { vrn: "UV12 WXY", drivers: ["George Robinson", "Susan Lee"] }
                    ]
                }
            ]
        }
    ];

    // Initialize client name dropdown functionality
    const clientNameInput = document.getElementById('clientName');
    const dropdownItems = document.querySelectorAll('.dropdown-menu .dropdown-item');

    // Handle client selection from dropdown
    dropdownItems.forEach(item => {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            const selectedClientName = this.textContent;
            clientNameInput.value = selectedClientName;

            // Find the client data that matches the selected name
            const client = clientData.find(c => c.name === selectedClientName);
            if (client) {
                populateClientData(client);
            }
        });
    });

    // Function to populate form with client data
    function populateClientData(client) {
        const policySelect = document.getElementById('policyNumber');
        const vehicleRegistrationInput = document.getElementById('vehicleRegistration');
        const driverNameInput = document.getElementById('driverName');

        // Clear existing policy options
        policySelect.innerHTML = '';

        // Add client's policies to dropdown
        if (client.policies && client.policies.length > 0) {
            client.policies.forEach(policy => {
                const option = document.createElement('option');
                option.value = policy.policyNumber;
                option.text = policy.policyNumber;
                policySelect.add(option);
            });

            // Select the first policy by default
            policySelect.value = client.policies[0].policyNumber;

            // Populate vehicle and driver with first vehicle from first policy
            const firstPolicy = client.policies[0];
            if (firstPolicy.vehicles && firstPolicy.vehicles.length > 0) {
                vehicleRegistrationInput.value = firstPolicy.vehicles[0].vrn;

                if (firstPolicy.vehicles[0].drivers && firstPolicy.vehicles[0].drivers.length > 0) {
                    driverNameInput.value = firstPolicy.vehicles[0].drivers[0];
                } else {
                    driverNameInput.value = '';
                }
            }
        }
    }

    // Handle policy selection change to update vehicle and driver fields
    const policySelect = document.getElementById('policyNumber');
    policySelect.addEventListener('change', function () {
        const selectedPolicy = this.value;
        const selectedClientName = clientNameInput.value;

        // Find the client and the selected policy
        const client = clientData.find(c => c.name === selectedClientName);
        if (client) {
            const policy = client.policies.find(p => p.policyNumber === selectedPolicy);
            if (policy && policy.vehicles && policy.vehicles.length > 0) {
                // Update vehicle and driver fields
                document.getElementById('vehicleRegistration').value = policy.vehicles[0].vrn;
                document.getElementById('driverName').value = policy.vehicles[0].drivers[0] || '';
            }
        }
    });
});